import { ZipCodeValidation } from '../../../../shared/Form';

export class ZipCodeValidationSE extends ZipCodeValidation {
  constructor(errorMessage: string = 'Entered value is not a valid zip code') {
    super(/^\d{3}\s\d{2}$/, errorMessage);
  }
}
